import React from 'react';
import Panel from 'muicss/lib/react/panel';
import Button from 'muicss/lib/react/button';
import Input from 'muicss/lib/react/input';
import Loader from 'halogen/ScaleLoader';
import axios from 'axios';
import querystring from 'querystring';

export default class NewTrustline extends React.Component {
  constructor(props) {
    super(props);
    this.state = {submitting: false};
  }

  onChangeValue(name, ev) {
    let state = {error: null, success: null};
    state[name] = ev.target.value;
    this.setState(state);
  }

  onSubmit() {
    this.setState({error: null, submitting: true});

    let urlValues = querystring.stringify(_.pick(this.state, ["code", "issuer"]));
    axios.post(`${process.env.HOST}/trustlines`, urlValues)
      .then(response => {
        this.setState({submitting: false, success: true});
      })
      .catch(err => {
        this.setState({submitting: false, error: err.response.data});
      });
  }

  render() {
    return <div>
      <div className={!this.state.submitting ? 'hide' : 'mui--text-center'}>
        {<Loader className="spinner" color="#2196f3" size="60px" margin="4px" />}
        <div className="mui--text-title status">Creating trustline...</div>
      </div>
      <div className={this.state.submitting ? 'hide' : ''}>
        <Input label="Asset code" floatingLabel={true} onChange={this.onChangeValue.bind(this, "code")} />
        <Input label="Asset issuer" floatingLabel={true} onChange={this.onChangeValue.bind(this, "issuer")} />
        <p><small>
          Trustline will be created in the test network. More info about <a href="https://www.stellar.org/developers/guides/concepts/assets.html" target="_blank">trustlines</a>.
        </small></p>
        {this.state.error ? <div className="mui--text-danger">{this.state.error}</div> : null}
        {this.state.success ? <div><i className="material-icons success">done</i> Created</div> : null}
        <Button
          color="primary"
          onClick={this.onSubmit.bind(this)}>Create a trustline</Button>
      </div>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/NewTrustline.js